import { useContext } from 'react'

import {
  Button, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'
import { useSetState } from '@domain-group/react-hooks'

import useApiKey from '@hooks/useApiKey'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

const MODAL_KEY = 'BulkCreateApiKeysModal'

type ModalCallbacks = {
  bulkCreateApiKeys: (payload: HandleCallbackActionParams) => void,
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const defaultState = {
  title: '',
}

const BulkCreateApiKeysModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal, bulkCreateApiKeys } = callbacks || {}

  const [state, setState] = useSetState(defaultState)
  const { title } = state

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { apiKey: initApiKey } = modalPayload

  const {
    callbacks: { bulkCreateApiKeys: createFn },
    creating,
  } = useApiKey(initApiKey)

  // To be used with handleCallbackAction
  const bulkCreateApiKeysPayload = {
    callbacks: {
      action: createFn,
      afterAction: closeModal,
    },
    entityParams: { agency_id: initApiKey?.owner_id, title },
    toastText: 'API Keys Created',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Bulk Create" titleSecondLine="API Keys" />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="* Title">
            <input
              name="title"
              onChange={e => setState({ title: e.target.value })}
              type="text"
              value={title}
            />
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!title}
          loading={creating}
          // @ts-expect-error TS2345
          onClick={() => bulkCreateApiKeys(bulkCreateApiKeysPayload)}
          size="large"
        >
          {title ? 'Create API Keys' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <BulkCreateApiKeysModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
